import { dealershipConsultantDto } from "../dtos/dealershipDto";
import { DealershipConsultant } from "../models/dealership";
import ApiService from "../services/api";

export const fetchConsultants = async (date: Date, dealershipId: string): Promise<DealershipConsultant[]> => {
    const apiService = new ApiService();
    
    try {
        const formattedDate = date.toLocaleDateString('pt-BR').split('/').reverse().join('-');
        console.log('Fetching consultants for date:', formattedDate, 'dealership:', dealershipId);
        
        const response = await apiService.get<any>(`/users/consultants?date=${formattedDate}&dn=${dealershipId}`);
        
        if (response.status === 200) {
            console.log('Consultants fetched successfully:', response.data);
            return response.data.map(dealershipConsultantDto);
        } else {
            console.warn('Unexpected response status:', response.status);
            return [];
        }
    } catch (error) {
        console.error('Error fetching consultants:', error);
        return [];
    }
}